import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { resolveEndpoint } from "../utils/utils";

function RequireAuth() {
  const [loading, setLoading] = useState(true);
  const [valid, setValid] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      setValid(false);
      setLoading(false);
      return;
    }

    fetch(`${resolveEndpoint()}/test`, {
      method: "GET",
      headers: { authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (res.ok) {
          setValid(true);
        } else {
          setValid(false);
        }
        setLoading(false);
      })
      .catch(() => {
        setValid(false);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading…</div>; // or your spinner
  }

  if (!valid) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return <Outlet />;
}

export default RequireAuth;
